export default "__VITE_ASSET__BBCAEsmG__"